export default "__VITE_ASSET__51210306__"